function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun-market-research-3239453");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-market-research-3239453",
  transform: "translate(0.848000, 0.863000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M417.932,42.246 L417.932,122.922 C403.151,117.8361 387.44,115.0314 371.268,115.0314 C357.452,115.0314 343.909,117.1408 330.756,121.0392 L330.752093,42.246 L417.932,42.246 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481.702,209.937 C462.366,166.195 419.046,137.984 371.292,137.984 C284.546,137.984 225.482,227.691 260.882,307.674 C286.03,364.518 352.277,394.951 413.982,371.494 C480.017,346.236 509.177,271.955 481.709,209.934 L481.702,209.937 Z M402.667,341.907 C357.343,359.196 308.55,337.0945 289.827,294.782 C263.409,235.177 308.35,169.682 371.292,169.682 C406.476,169.682 438.491,190.498 452.757,222.725 C472.952,268.495 451.5148,323.255 402.671,341.905 L402.667,341.907 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "-2.84217094e-14 0 87.266 0 87.266 367.91 -2.84217094e-14 367.91"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "110.262 127.747 197.528 127.747 197.528 212.888 197.524094 212.915344 197.524094 367.905344 110.262094 367.905344"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.502,367.847 L220.502,224.397 L231.955,224.397 C224.5409,254.264 226.4589,286.667 239.8378,316.917 C248.6855,336.917 261.8028,354.159 277.7948,367.851 L220.502,367.847 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429.442,390.157 C444.251,383.6062 452.512,376.903 458.395,372.872 C460.1294,376.3759 464.5317,384.938 465.5747,388.618 L403.9417,415.841 L396.9534,400.126 C406.2151,398.458 418.9574,394.794 429.4414,390.1572 L429.442,390.157 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M489.432,525.997 C476.28,531.9697 459.186,525.96575 453.776,510.649 L425.452,431.465 L462.651,415.043 L502.198,489.254 C509.2644,502.504 503.9949,519.539 489.432,525.996 L489.432,525.997 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528.3023,367.847 L481.552,367.847 C479.6575,364.0306 478.0872,360.8861 476.2903,356.824 C514.3253,315.992 526.6773,254.804 502.7163,200.624 C498.439,190.956 493.1655,181.929 487.0643,173.632 L528.3023,173.632 L528.3023,367.847 Z",
  id: "Path"
})));

var SvgMarketResearch = function SvgMarketResearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "530px",
    height: "530px",
    viewBox: "0 0 530 530",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarketResearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MarketResearch.1570e9a7.svg";
export { ForwardRef as ReactComponent };